import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGate, useUnit } from 'effector-react';
import { $pathname, HaveSectionAccess, history } from '@features/common';
import { currentPageChanged } from '@features/navbar/models';
import { ChatWithTabs } from '@features/socket-chats-reworked/components/chat-with-tabs';
import { FilterMainDetailLayout } from '@shared/ui';
import { ErrorMessage, Loader } from '@ui/index';
import {
  $errorTicket,
  $isErrorDialogOpenTicket,
  $ticket,
  changedErrorDialogVisibilityTicket,
  path,
  TicketGate,
} from '../models';
import { $isLoadingTicket } from '../models/ticket/ticket.model';
import { Detail } from '../organisms';

export const TicketPage: FC = () => {
  const { t } = useTranslation();
  const [pathname, isErrorDialogOpen, error, isLoading, ticket] = useUnit([
    $pathname,
    $isErrorDialogOpenTicket,
    $errorTicket,
    $isLoadingTicket,
    $ticket,
  ]);

  const ticketId = Number.parseInt((pathname as string).split('/')[2], 10);

  useGate(TicketGate, { ticketId });

  const getTitle = () => {
    if (ticket.ticket_number) {
      return `${t('Request')} №${ticket.ticket_number}`;
    }
    return t('Request');
  };

  useEffect(() => {
    (currentPageChanged as any)({
      title: getTitle(),
      back: () => history.push(path),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticket]);

  const onClose = () => changedErrorDialogVisibilityTicket(false);

  return (
    <>
      <Loader isLoading={isLoading} />

      <ErrorMessage isOpen={isErrorDialogOpen} onClose={onClose} error={error} />

      <FilterMainDetailLayout
        main={<Detail />}
        detail={
          Number(ticket.id) === Number(ticketId) ? (
            <ChatWithTabs
              mainChatId={ticket.channel}
              technicalSupportChatId={ticket.support?.channel?.id}
              token={ticket.related_userdata_token}
              standalone
              hideLeaveButton
            />
          ) : null
        }
        params={{
          filterWidth: '1fr',
          mainWidth: '1fr',
          detailWidth: '2fr',
        }}
      />
    </>
  );
};

const RestrictedTicketPage: FC = () => (
  <HaveSectionAccess>
    <TicketPage />
  </HaveSectionAccess>
);

export default RestrictedTicketPage;
